import produce from "immer";
import React, { FC, useState } from "react";
import { SketchPicker } from "react-color";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../actions/elementListAction";
import { Element } from "../../../models/elementModel";
import {
  BlockBtn,
  BtnSize,
  BtnType,
  OutlinedBtnType,
} from "../../../utils/constants";
import ElementStyleProperties from "../common/elementStyleProperties";
import Collapse from "react-bootstrap/Collapse";
import "./elementProprtiesPanal.scss";
import Switch from "react-switch";
import { IoColorPalette } from "react-icons/io5";
import { FaEraser } from "react-icons/fa";
export interface ButtonElementPropertiesProps {
  element: Element;
}
const ButtonProperties: FC<ButtonElementPropertiesProps> = ({ element }) => {
  const [colorPicker, setColorPicker] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const outlinedBtnOrNot = (outlined: boolean) => {
    if (outlined) {
      return OutlinedBtnType.map((item, i) => {
        return (
          <option className={"btn " + item.value} key={i} value={item.value}>
            {item.name}
          </option>
        );
      });
    } else {
      return BtnType.map((item, i) => {
        return (
          <option className={"btn " + item.value} key={i} value={item.value}>
            {item.name}
          </option>
        );
      });
    }
  };
  return (
    <div className="container mt-3">
      <div className="form-group row">
        <label
          htmlFor="elementName"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Name
        </label>
        <div className="col-sm-8">
          <input
            value={`${element.name}`}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.name = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="elementName"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="valid-message"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Button Text
        </label>
        <div className="col-sm-8">
          <input
            value={element.properties.btnText}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.btnText = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="valid-message"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="btn-outline"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          OutLined
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.outlinedBtn}
            onChange={(checked) => {
              const newElement = produce(element, (draft) => {
                draft.properties.outlinedBtn = checked;
                if (checked) {
                  draft.properties.btnType = "btn-outline-primary";
                } else {
                  draft.properties.btnType = "btn-primary";
                }
              });
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="btn-outline"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="btn-type"
          className="col-sm-4 col-form-label font-size-12 align-text-left pr-0"
        >
          Button Type
        </label>
        <div className="col-sm-8">
          <select
            value={element.properties.btnType}
            id="btn-type"
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.btnType = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
          >
            {outlinedBtnOrNot(element.properties.outlinedBtn)}
          </select>
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="background-color"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Fill Color
        </label>
        <div className="col-sm-8">
          <div className="row">
            {colorPicker && (
              <SketchPicker
                color={element.styles.backgroundColor}
                onChange={(color) => {
                  const newElement = produce(element, (draft) => {
                    draft.styles.backgroundColor = color.hex;
                  });
                  dispatch(startEditElement(newElement));
                }}
              />
            )}
            <button
              className="btn btn-block btn-dark btn-theam color-picker-btn-margine"
              onClick={() => {
                setColorPicker(!colorPicker);
              }}
            >
              <IoColorPalette size={25} />
            </button>
          </div>
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="font-color"
          className="col-sm-4 col-form-label font-size-12 align-text-left "
        >
          Reset Fill Color
        </label>
        <div className="col-sm-8">
          <div className="row items-align-center">
            <button
              className="btn btn-block btn-dark btn-theam"
              onClick={() => {
                const newElement = produce(element, (draft) => {
                  draft.styles.backgroundColor = "";
                });
                dispatch(startEditElement(newElement));
              }}
            >
              {" "}
              <FaEraser size={25} />{" "}
            </button>
          </div>
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="btn-size"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Button Size
        </label>
        <div className="col-sm-8">
          <select
            value={element.properties.sizebtn}
            id="btn-size"
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.sizebtn = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
          >
            {BtnSize.map((item, i) => {
              return (
                <option key={i} value={item.value}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="btn-size"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Wide
        </label>
        <div className="col-sm-8">
          <select
            value={element.properties.blockBtn}
            id="btn-size"
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.blockBtn = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
          >
            {BlockBtn.map((item, i) => {
              return (
                <option key={i} value={item.value}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="field-disabled"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Disable
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.disabled}
            onChange={() => {
              const newElement = produce(element, (draft) => {
                draft.properties.disabled = !draft.properties.disabled;
              });
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="field-disabled"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="btn-outline"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Display
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.display}
            onChange={() => {
              const newElement = produce(element, (draft) => {
                draft.properties.display = !draft.properties.display;
              });
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="btn-outline"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="tooltip"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Tooltip
        </label>
        <div className="col-sm-8">
          <textarea
            className="form-control theam-textbox font-size-12 items-align-left"
            name="tooltip"
            id="tooltip"
            placeholder="Enter tooltip"
            cols={30}
            rows={2}
            value={element.properties.tooltip}
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.tooltip = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default ButtonProperties;
